<div class="predictive-model-container">
    <div *ngIf="isProducer" fxLayout="column" class="mb-30" fxLayoutAlign="center center">
        <div mat-dialog-title class="txt-h-24-7">{{ 'Production forecast'|i18n }}</div>
        <div class="txt-p-16-4">
            {{ 'Since this resource is a producer, its predictions are derived from the predictive models of the production facilities connected to it.'|i18n }}
        </div>
    </div>
    <form *ngIf="!isProducer" [formGroup]="form" fxLayout="column" fxLayoutGap="20px" class="mb-20">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div fxLayout="row" fxLayoutAlign="end" fxFlex="40" class="t-right">
                {{ ('Predictive model'|i18n) + ':*' }}
            </div>
            <mat-select app-small-select formControlName="modelType"
                        placeholder="{{'Predictive model'|i18n}}"
                        (selectionChange)="onModelTypeChange($event)">
                <mat-option *ngFor="let modelType of modelTypes" [value]="modelType">
                    <app-icon [name]="modelType|predictiveModelIcon"></app-icon>&nbsp;
                    <em>{{ modelType|predictiveModelType|i18n }}</em>
                </mat-option>
            </mat-select>
        </div>
        <ng-container [ngSwitch]="form.controls.modelType.value">
            <ng-container *ngSwitchCase="ModelType.PV">
                <div app-divider class="divider"></div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="start" fxFlex="40" class="app-section-title">
                        {{ ('Power model'|i18n) + ' PV' }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Power model'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="powerModel"
                                placeholder="{{'Power model'|i18n}}">
                        <mat-option *ngFor="let model of models" [value]="model">
                            {{ model }}
                        </mat-option>
                    </mat-select>
                </div>
                <div app-divider class="divider"></div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="start" fxFlex="40" class="app-section-title">
                        {{ ('Technical params'|i18n) + ' PV' }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('PV array area'|i18n) + ':*' }}
                    </div>
                    <div fxFlex app-input-container>
                        <input app-input
                               type="number"
                               step="0.01"
                               formControlName="solarCellArea"
                               (input)="limitDecimals(form, 'solarCellArea')"
                               class="end">
                    </div>
                    <div fxFlex="4">m&#178;</div>
                    <app-icon name="fas-info-circle"
                              [title]="('PV array area: area in m2 of the installed panels; 300W per panel can be considered as a reference value, a standard panel is 1.6m2, or 187 W/m2; the data entered must be compatible with the nominal power rating entered during the creation of the PV resource; based on the example above, it is recommended to enter the value corresponding to the nominal power rating in watts / 187'|i18n)">
                    </app-icon>
                    <div app-suffix fxFlex="35"></div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Cell reference efficiency'|i18n) + ':*' }}
                    </div>
                    <div fxFlex app-input-container>
                        <input app-input
                               type="number"
                               min="1"
                               max="100"
                               step="0.01"
                               formControlName="referenceEfficiency"
                               (input)="limitDecimals(form, 'referenceEfficiency')"
                               class="end">
                        <div *ngIf="form.controls.referenceEfficiency.invalid" app-error>{{ 'Invalid value'|i18n }}</div>
                    </div>
                    <div fxFlex="4">%</div>
                    <app-icon name="fas-info-circle"
                              [title]="('Cell reference efficiency: value between 1% and 100% (typical value is 19%)'|i18n)">
                    </app-icon>
                    <div app-suffix fxFlex="35"></div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Packing factor'|i18n) + ':*' }}
                    </div>
                    <div fxFlex app-input-container>
                        <input app-input
                               type="number"
                               min="1"
                               max="100"
                               step="0.01"
                               formControlName="packingFactor"
                               (input)="limitDecimals(form, 'packingFactor')"
                               class="end">
                        <div *ngIf="form.controls.packingFactor.invalid" app-error>{{ 'Invalid value'|i18n }}</div>
                    </div>
                    <div fxFlex="4">%</div>
                    <app-icon name="fas-info-circle"
                              [title]="('Packing factor (or spacing factor): ratio of the area of the installed panel array over the area dedicated to it (typical values: 50% for plants on a flat surface and 100% for plants on a sloped surface)'|i18n)">
                    </app-icon>
                    <div app-suffix fxFlex="35"></div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('System efficiency'|i18n) + ':*' }}
                    </div>
                    <div fxFlex app-input-container>
                        <input app-input
                               type="number"
                               min="1"
                               max="100"
                               step="0.01"
                               formControlName="systemEfficiency"
                               (input)="limitDecimals(form, 'systemEfficiency')"
                               class="end">
                        <div *ngIf="form.controls.systemEfficiency.invalid" app-error>{{ 'Invalid value'|i18n }}</div>
                    </div>
                    <div fxFlex="4">%</div>
                    <app-icon name="fas-info-circle"
                              [title]="('System efficiency: performance ratio, it is a value between 1% and 100% that takes into account the losses of all other devices such as inverters, cables, switches, etc. (typical value is 85%)'|i18n)">
                    </app-icon>
                    <div app-suffix fxFlex="35"></div>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="ModelType.WIND">
                <div app-divider class="divider"></div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="start" fxFlex="40" class="app-section-title">
                        {{ ('Power model'|i18n) + ' ' + ('wind'|i18n) }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Power model'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="powerModel"
                                placeholder="{{'Power model'|i18n}}">
                        <mat-option *ngFor="let model of models" [value]="model">
                            {{ model }}
                        </mat-option>
                    </mat-select>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="ModelType.LOAD">
                <div app-divider class="divider"></div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="start" fxFlex="40" class="app-section-title">
                        {{ 'Load parameters'|i18n }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Active power model'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="activePowerModel"
                                placeholder="{{'Active power model'|i18n}}">
                        <mat-option *ngFor="let model of models" [value]="model">
                            {{ model }}
                        </mat-option>
                    </mat-select>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Active power measure'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="activePowerMeasure"
                                placeholder="{{'Active power measure'|i18n}}">
                        <mat-option *ngFor="let measure of loadActivePowerMeasures" [value]="measure.deviceKey">
                            {{ measure.name|i18n }}
                        </mat-option>
                    </mat-select>
                </div>
                <!--                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">-->
                <!--                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">-->
                <!--                        {{('Reactive power model'|i18n) + ':'}}-->
                <!--                    </div>-->
                <!--                    <mat-select app-small-select formControlName="reactivePowerModel"-->
                <!--                                placeholder="{{'Reactive power model'|i18n}}">-->
                <!--                        <mat-option *ngFor="let model of models" [value]="model">-->
                <!--                            {{model}}-->
                <!--                        </mat-option>-->
                <!--                    </mat-select>-->
                <!--                </div>-->
                <!--                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">-->
                <!--                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">-->
                <!--                        {{('Reactive power measure'|i18n) + ':'}}-->
                <!--                    </div>-->
                <!--                    <mat-select app-small-select formControlName="reactivePowerMeasure"-->
                <!--                                placeholder="{{'Reactive power measure'|i18n}}">-->
                <!--                        <mat-option *ngFor="let measure of loadReactivePowerMeasures" [value]="measure.deviceKey">-->
                <!--                            {{measure.name|i18n}}-->
                <!--                        </mat-option>-->
                <!--                    </mat-select>-->
                <!--                </div>-->
            </ng-container>
            <ng-container *ngSwitchCase="ModelType.THERMAL_LOAD">
                <div app-divider class="divider"></div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="start" fxFlex="40" class="app-section-title">
                        {{ 'Thermal load parameters'|i18n }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Power model'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="powerModel"
                                placeholder="{{'Power model'|i18n}}">
                        <mat-option *ngFor="let model of models" [value]="model">
                            {{ model }}
                        </mat-option>
                    </mat-select>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Power measure'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="powerMeasure"
                                placeholder="{{'Power measure'|i18n}}">
                        <mat-option *ngFor="let measure of thLoadPowerMeasures" [value]="measure.deviceKey">
                            {{ measure.name|i18n }}
                        </mat-option>
                    </mat-select>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="ModelType.PROSUMER">
                <div app-divider class="divider"></div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="start" fxFlex="40" class="app-section-title">
                        {{ "Prosumer parameters"|i18n }}
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Prosumer model'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="prosumerModel"
                                placeholder="{{'Prosumer model'|i18n}}">
                        <mat-option *ngFor="let model of models" [value]="model">
                            {{ model }}
                        </mat-option>
                    </mat-select>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Absorbed power measure'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="absorbedPowerMeasure"
                                placeholder="{{'Absorbed power measure'|i18n}}">
                        <mat-option *ngFor="let measure of prosumerAbsPowerMeasures" [value]="measure.deviceKey">
                            {{ measure.name|i18n }}
                        </mat-option>
                    </mat-select>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="22" class="t-right">
                        {{ ('Injected power measure'|i18n) + ':*' }}
                    </div>
                    <mat-select app-small-select formControlName="injectedPowerMeasure"
                                placeholder="{{'Injected power measure'|i18n}}">
                        <mat-option *ngFor="let measure of prosumerInjPowerMeasures" [value]="measure.deviceKey">
                            {{ measure.name|i18n }}
                        </mat-option>
                    </mat-select>
                </div>
            </ng-container>
        </ng-container>
    </form>
    <button mat-stroked-button color="primary" class="clear-button"
            (click)="onClickClear()">
        {{ 'Reset'|i18n }}
    </button>
</div>
